export const defaultState = {
  valuesByUuid: {},
  isUuidValidated: {},
};

// TODO: remove when porting messaging forms to React...
export default function gwtInputs(state = defaultState, action) {
  switch (action.type) {
    case 'GWT_SET_INPUT_VALUE':
    case 'GWT_SET_MESSAGING_PROPERTY_VALUE': {
      const { uuid, value } = action.payload;
      return {
        ...state,
        valuesByUuid: {
          ...state.valuesByUuid,
          [uuid]: value,
        },
      };
    }
    case 'GWT_SHOW_INPUT_VALIDATION':
    case 'GWT_SHOW_MESSAGING_PROPERTY_VALIDATION': {
      return {
        ...state,
        isUuidValidated: {
          ...state.isUuidValidated,
          [action.payload]: true,
        },
      };
    }
    default:
      return state;
  }
}
